export default {"src":"/_next/static/media/black-room-names-en.bedcd519.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};